import {ImageFragment} from '../../../../gql/graphql';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';

export class ImageModel {
  public altText: string | null;
  public height?: number;
  public width?: number;
  public src: string;

  constructor(params: ImageModel) {
    this.altText = params.altText;
    this.height = params.height;
    this.width = params.width;
    this.src = params.src;
  }

  public static fromCheckoutV1(name: string, image?: ImageFragment | null) {
    if (!image || (!image.id && !image.url)) {
      return undefined;
    }
    return new ImageModel({
      altText: image.altText || name,
      height: mapNullToUndefined(image.height),
      width: mapNullToUndefined(image.width),
      src: image.id ?? image.url!,
    });
  }
}
